import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

interface SettingsSubsectionProps {
  children: ReactNode;
  title: string;
}

export const SettingsSubsection = ({
  title,
  children,
}: SettingsSubsectionProps) => (
  <div className="flex flex-col gap-5 px-6 pb-5 pt-2">
    <div className="flex w-full items-center border-b border-primary py-1">
      <Typography variant="label-xs" color="secondary" className="w-full">
        {title}
      </Typography>
    </div>
    {children}
  </div>
);
